<div
  (click)="badgeClicked()"
  class="badge rounded-pill bg-light px-4 py-2 text-secondary badge__shadow"
>
  <ng-content></ng-content>
</div>
